/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 11:59:33 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Edit,
  fetchEnd,
  fetchStart,
  FormTab,
  TabbedForm,
  useDataProvider,
  useNotify,
  usePermissions,
} from 'react-admin';
import { connect, useDispatch } from 'react-redux';
import { AccessDenied } from 'Layout';
import TowerDetail from './Tabs/TowerDetail';
import InspectionDetail from './Tabs/InspectionDetail';
import TowerInspectionActions from './editActions';
import { downloadFile } from 'utils';
import { isApprover, isSuperAdmin } from 'utils/roles';

const onClick = ({
  dataProvider,
  reduxDispatch,
  inspectionId,
  notify,
  formValues,
}) => {
  if (
    formValues &&
    inspectionId &&
    formValues[inspectionId] &&
    formValues[inspectionId].tower.id
  ) {
    reduxDispatch(fetchStart());
    const towerId = formValues[inspectionId].tower.id;
    return dataProvider('DOWNLOAD', 'Inspection', { id: towerId })
      .then(result => {
        reduxDispatch(fetchEnd());
        console.log ('result', result , " result.data.downloadUrl", result.data.downloadUrl);
        if (result.data.downloadUrl) {
          return downloadFile({
            uri: result.data.downloadUrl,
            filename: `Tower ${towerId} Inspection Report.pdf`,
          });
        }
        return notify('error.noPdf', 'warning');
      })
      .catch(error => {
        reduxDispatch(fetchEnd());
        const {
          extensions: { code },
          message,
        } = error.graphQLErrors[0];
        if (code !== 'INTERNAL_SERVER_ERROR') {
          return notify(message, 'warning');
        }
        return notify('error.generic', 'warning');
      });
  }
  return notify('error.generic', 'warning');
};

const InspectionEdit = props => {
  const dataProvider = useDataProvider();
  const reduxDispatch = useDispatch();
  const notify = useNotify();
  const { permissions } = usePermissions();
  const superAdmin = isSuperAdmin(permissions);
  const {
    hasDelete,
    hasCreate,
    hasShow,
    hasList,
    hasEdit,
    formValues,
    className,
    onSave,
    location,
    dispatch,
    ...rest
  } = props;

  const isChecklist =
    (location && location.state && location.state.checklist) || false;

  const isAllowedToDownload =
    formValues[props.id] && formValues[props.id].permissions.allowPDFExport;

  return isApprover(permissions) ? (
    <Edit
      title={'resources.Inspection.fields.inspectionTowerDetails'}
      actions={
        !isChecklist && (
          <TowerInspectionActions
            isAllowedToDownload={superAdmin ? true : isAllowedToDownload}
            onClick={() =>
              onClick({
                dataProvider,
                reduxDispatch,
                inspectionId: rest.id,
                notify,
                formValues,
              })
            }
          />
        )
      }
      {...rest}
    >
      <TabbedForm redirect={false} toolbar={null}>
        <FormTab label={'resources.Inspection.fields.tab1'}>
          <TowerDetail {...props} />
        </FormTab>
        <FormTab label={'resources.Inspection.fields.tab2'}>
          <InspectionDetail {...props} />
        </FormTab>
      </TabbedForm>
    </Edit>
  ) : (
    <AccessDenied />
  );
};

const mapStateToProps = state => ({
  formValues:
    state.admin.resources.Inspection && state.admin.resources.Inspection.data,
});

export default connect(mapStateToProps)(InspectionEdit);
